export default __webpack_public_path__ + "ac252668d0bb442efc6bc06055c9cf1e.svg";